<script setup lang="ts">
import { Button } from '@/components/ui/button'
import { useRouter } from 'vue-router'
import AuthLayout from '@/components/layout/AuthLayout.vue'

const router = useRouter()

const handleSignupPress = () => {
  router.push('/auth/register')
}

const handleLoginPress = () => {
  router.push('/auth/login')
}
</script>

<template>
  <AuthLayout>
    <div class="flex flex-col items-center gap-8">
      <img
        src="/images/create-account-avatar.png"
        alt="Create Account"
        class="w-64 h-64 object-contain"
      />

      <div class="max-w-md w-full space-y-6">
        <h1 class="text-3xl font-bold text-center">
          Create your<br />Maximo account
        </h1>

        <p class="text-xl text-center text-gray-700">
          Start your smart money journey today
        </p>

        <div class="space-y-4">
          <Button size="lg" class="w-full" @click="handleSignupPress">
            Sign Up
          </Button>

          <Button
            size="lg"
            variant="outline"
            class="w-full"
            @click="handleLoginPress"
          >
            Log in
          </Button>
        </div>

        <p class="text-sm text-center text-gray-600">
          By continuing you accept our<br />
          <a href="#" class="underline">Terms & Conditions</a> and
          <a href="#" class="underline">Privacy Policy</a>
        </p>
      </div>
    </div>
  </AuthLayout>
</template>
